<template>
  <va-edit-layout>
    <audio-fragments-form :id="id" :title="title" :item="item"></audio-fragments-form>
    <audio-uploader :id="id" :item="item"></audio-uploader>
  </va-edit-layout>
</template>

<script>
import AudioUploader from '@/components/AudioUploader.vue';

export default {
  components: {
    AudioUploader,
  },
  // eslint-disable-next-line
  props: {
    id: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    item: {
      type: Object,
      default: null,
    },
  },
};
</script>
